import template from "./quote-section-name-modal.html";

const QuoteSectionNameModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class QuoteSectionNameModalController {
    $onInit() {
      this.sectionName = this.resolve.sectionName;
    }

    save(name) {
      this.close({ $value: name });
    }

    close() {
      this.dismiss({ $value: "close" });
    }
  },
};

export default QuoteSectionNameModalComponent;
